import PollsQuestionsModel from '../Apis/PollsQuestions'
import Controller from './Controller'

export default class PollsQuestionsController extends Controller {
  constructor(poll) {
    super(new PollsQuestionsModel(poll))
  }
}
